var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDateType2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 11.917H7.58333V14.0837H9.75V11.917ZM14.0833 11.917H11.9167V14.0837H14.0833V11.917ZM18.4167 11.917H16.25V14.0837H18.4167V11.917ZM20.5833 4.33366H19.5V2.16699H17.3333V4.33366H8.66667V2.16699H6.5V4.33366H5.41667C4.21417 4.33366 3.26083 5.30866 3.26083 6.50033L3.25 21.667C3.25 22.2416 3.47827 22.7927 3.8846 23.1991C4.29093 23.6054 4.84203 23.8337 5.41667 23.8337H20.5833C21.775 23.8337 22.75 22.8587 22.75 21.667V6.50033C22.75 5.30866 21.775 4.33366 20.5833 4.33366ZM20.5833 21.667H5.41667V9.75033H20.5833V21.667Z",
    fill: "#727272"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateType2);
export default __webpack_public_path__ + "static/media/DateType2.b8611325c5fdce907ca6a97ad7b656f3.svg";
export { ForwardRef as ReactComponent };